// extracted by mini-css-extract-plugin
export default {"buttonContainer":"buttonContainer","form":"form","section":"section"};